import React, { useEffect } from 'react';
import { ShoppingCartIcon, InfoIcon } from 'lucide-react';
import AOS from 'aos';
import Star from '../../assets/images/star.svg';
import ProfilerBannerImg from '../../assets/images/profilerService.png';
import SignatureBannerImg from '../../assets/images/signatureService.png';
import HepBannerImg from '../../assets/images/profilerJourneyTab.png';
import './services.css';
import TimelineProfiler from '../../common/components/timeline/timelineProfiler';
import TimelineHEP from '../../common/components/timeline/timelineHEP';
import TimelineSignature from '../../common/components/timeline/timelineSignature';
import BeatsIcon from '../../assets/images/commonBeats.svg';
import SplitHeart from '../../assets/images/splitHeart.svg';
import TimelineMobileProfiler from '../../common/components/timelineMobile/timelineMobileProfiler';
import TimelineMobileSignature from '../../common/components/timelineMobile/timelineMobileSignature';
import TimelineMobileHEP from '../../common/components/timelineMobile/timelineMobileHEP';
import {
    REACT_APP_CAD_BUY_VOUCHERS,
    REACT_APP_CAD_URL,
    REACT_APP_CAD_CONSUMER_URL_PROFILER,
    REACT_APP_CAD_CONSUMER_URL_SIGNATURE,
  } from '../../common/components/utils/constants';


/* jscpd:ignore-start */
function Services() {
    useEffect(() => {
        AOS.init();
        let tabId = window.location.hash || '#hep';
    
        const activateTab = (tabId: string) => {
            const tabs = ['#hep', '#profiler', '#signature'];
            tabs.forEach((id) => {
                const tabContent = document.querySelector(id);
                const tabLink = document.querySelector(`${id}Tab`);
                if (id === tabId) {
                    tabContent?.classList.add("active", "show");
                    tabLink?.classList.add("active");
                } else {
                    tabContent?.classList.remove("active", "show");
                    tabLink?.classList.remove("active");
                }
            });
        };
    
        activateTab(tabId);
    
        window.addEventListener('hashchange', () => {
            activateTab(window.location.hash);
        });
    
        return () => {
            window.removeEventListener('hashchange', () => {
                activateTab(window.location.hash);
            });
        };
    }, []);
    
    const isMobileDevice = () => {
        return /Mobi|Android/i.test(navigator.userAgent);
    };

    const handleTryItNowClick = (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        url: string
    ) => {
        if (!isMobileDevice()) {
            e.preventDefault();
            alert('Kindly use your mobile device to register or sign in.');
        } else {
            window.location.href = url;
        }
    };

    const handleBuyNowClick = () => {
            setTimeout(() => {
            window.location.href = `${REACT_APP_CAD_BUY_VOUCHERS}`;
        }, 2000);
    };

    const handleGoToHepServiceClickMobile = (
    e: React.MouseEvent<HTMLButtonElement>
) => {
    if (!isMobileDevice()) {
        e.preventDefault();
        alert('Kindly use your mobile device to register or sign in.');
    } else {
        setTimeout(() => {
            window.location.href = REACT_APP_CAD_URL;
        }, 2000);
    }
};
    return (
        <div id="services" className='max-width-layout'>
            <section id="about" className="about ">
                <div data-aos="fade-up">
                    <div className="row" data-aos="fade-up" data-aos-delay="200">
                        <div className="col-lg-12">
                            <ul className="nav nav-pills text-center">
                                <li>

                                    <a
                                        className="nav-link active"
                                        data-bs-toggle="pill"
                                        href="#hep"
                                        id="hepTab"
                                    >
                                        <div
                                            className="hepTab"
                                        />
                                        <div>HEP</div>
                                    </a>
                                </li>
                                <li>

                                    <a
                                        className="nav-link"
                                        data-bs-toggle="pill"
                                        href="#profiler"
                                        id="profilerTab"
                                    >
                                        <div
                                            className="profilerTab"
                                        />
                                        <div>Profiler</div>
                                    </a>
                                </li>
                                <li>

                                    <a
                                        className="nav-link"
                                        data-bs-toggle="pill"
                                        href="#signature"
                                        id="signatureTab"
                                    >
                                        <div
                                            className="signatureTab"
                                        />
                                        <div>Signature</div>
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content tab-content-journey">
                            <div className="tab-pane fade show active col-12" id="hep">
                                <div className="row">
                                    <div className="hep-intro">
                                        <div className="hep-text">
                                            <p>
                                                A measure of your heart strength that helps you proactively check
                                                your heart health, detect hidden risks, and take steps to improve
                                                your wellbeing.
                                            </p>
                                            <div className="buttons">
                                                <button type="button" name="buy_vouchers"   className="btn-buy"
                                                   onClick={handleBuyNowClick}
                                                >
                                                    <ShoppingCartIcon /> Buy Now
                                                </button>
                                                <button name="launch_hep_service"  className="btn-service"
                                                    onClick={handleGoToHepServiceClickMobile}
                                                    >
                                                    <InfoIcon /> Go to Heart Energy Service
                                                </button>
                                            </div>
                                            <p className="note">
                                                After purchasing your voucher, click "Go to Heart Energy Service" to
                                                activate your HQI.
                                            </p>
                                            </div>
                                            <div className="hep-icon">
                                        <img src={HepBannerImg} alt="HEP Banner" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="journey-info-container">
                                        <h2>Heart Energy Potential (HEP)</h2>
                                        <p>
                                        The HEP service is an instant scanner that helps you understand early changes related to heart health and lifestyle.​ 
                                        </p>
                                        <p>
                                        It provides indicative insights into factors such as lifestyle stress, work done by your heart, efficiency and general fitness – using proprietary algorithms and data trends.
                                        </p>
                                        <p>
                                        HEP is a unique digital service that uses digital biomarkers like heart energy and heart efficiency to support wellness journeys that can help users track changes to their heart wellbeing.
                                        </p>
                                        <br />
                                        {/* <p>
                                            It is a 5 day analysis that will keep track the patterns
                                            of your resting heart and also help uncover:
                                        </p> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="row information-points">
                                        <div className="col-xl-6 col-sm-6 col-6 p-0 m-0 d-flex align-items-center flex-column">
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="HEP" className="star-icon" />
                <li id='left'>Get insights into heart efficiency and understand potential impact​</li>
            </div>
            <br />
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="HEP" className="star-icon" />
                <li>Develop your Heart Quality Index (HQI) which gives you strengths and weaknessess</li>
            </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0 m-0 d-flex align-items-center flex-column " style={{ paddingLeft: '5px', paddingBottom: '10px' }}>

            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="HEP" className="star-icon" />
                <li>Learn heart energy insights and correlate it to your stress levels​</li>
            </div>
            <br />
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="HEP" className="star-icon" />
                <li>Find impactful insights about influence of mental health on your heart and vice versa​</li>
            </div>
        </div>
                                            
                                           
                                        </div>
                                    </div>
                                    </div>
                                     <br />
                                    <div id="information">
                                        <div className="row">
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 about-desc p-4 m-0'>
                                                <h3>Why use HEP?</h3>
                                                <br />
                                                <ul className="one-column">
                                                    <li>Daily stress, pollution, and job pressure may be affecting you—find out how.</li>
                                                    <li>Want to better understand how lifestyle patterns may interct with your overall well-being.</li>
                                                    <li>Feeling low on energy or feeling fatigued? Check your heart energy to understand wellbeing impact.</li>
                                                    <li>Concerned about heart health or managing conditions like diabetes or hypertension?</li>
                                                    <li>Curious about when to schedule your health checkup? Use insights on heart energy and heart efficiency to guide your wellness journey.</li>
                                                    <li>Taking weight loss medications, consuming dietary supplements and/or gymming regularly? Use wellbeing insights based on heart energy and heart efficiency to reflect on your regimen.</li>
                                                    <li>Using our indicative insights, monitor positive/negative changes to your heart wellbeing caused by diet, sleep and exercise.</li>
                                                </ul>
                                            </div>
                                            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex p-0 m-0'>
                                                <img
                                                    src={ProfilerBannerImg}
                                                    alt="HEP"
                                                    className="img-fluid w-100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div id="beats">
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  m-0 beats-image">
                                                <img
                                                id='img1'
                                                    src={SplitHeart}
                                                    alt="Beats"
                                                    className="img-fluid" 
                                                />
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  m-0 beats-content">
                                                <h3>How we do it:</h3>
                                                <ul className='hep-list'>
                                                    <li>We use PPG technology and machine learning to highlight early changes to your heart wellbeing</li>
                                                    <li>We use machine learning to generate personalized wellbeing  profiles which can be used to track early changes to your heart wellbeing</li>
                                                    <li>We provide an estimate of heart-related energy trends based on your resting parameters</li>
                                                    <li>We derive indicative metrics on the work done by your heart and indicative insights on the efficiency of your cardiovascular system​​</li>
                                                    <li>We consider your self reported mental wellness indicators and correlate them with resting heart parameters to personalize your heart wellbeing profile​​</li>
                                                    <li>We provide insights and guidance drawn from your profile to support your heart-wellness and decision making​​</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="timeline">
                                        <h2 className="small-heading">The process involves measuring your vitals, posing questions,and constructing a resting heart profile based on: </h2>
                                       
                                        <TimelineHEP />
                                        <TimelineMobileHEP/>
                                        <div className="d-flex" id='buy-now'>
                                        <button  
                                            type="button"
                                            name="buy_vouchers_footer"
                                            className="btn-try-now scrollto"
                                            onClick={handleBuyNowClick}
                                        >
                                            Buy now
                                        </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade show col-12" id="profiler">
                                <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="journey-info-container">
                                        <h2>Profiler</h2>
                                        <p>
                                        Profiler is designed as a concise 5-day program where you engage for no more than five minutes daily using just your smartphone. 
                                        </p>
                                        <p>
                                        This journey offers insights into various parameters that gauge your heart's health while at rest, tracks patterns, and presents a heart health score upon completion.
                                        </p>
                                        <br />
                                        <div className="d-flex" id='try-now'>
                                        <a
                                            href={`${REACT_APP_CAD_CONSUMER_URL_PROFILER}`}
                                            target="_self"
                                            className="btn-try-now scrollto"
                                            onClick={(e) =>
                                                handleTryItNowClick(e, REACT_APP_CAD_CONSUMER_URL_PROFILER)
                                            }
                                        >
                                            Try it now
                                        </a>
                                        </div>
                                        {/* <p>
                                            It is a 5 day analysis that will keep track the patterns
                                            of your resting heart and also help uncover:
                                        </p> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="row information-points">
                                        <div className="col-xl-6 col-sm-6 col-6 p-0 m-0 d-flex align-items-center flex-column">
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li id='left'>Resting heart health score</li>
            </div>
            <br />
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Resilience & reliability metrics</li>
            </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0 m-0 d-flex align-items-center flex-column " style={{ paddingLeft: '5px', paddingBottom: '10px' }}>

            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Progression in your overall health</li>
            </div>
            <br />
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Indicators of changes in your overall health</li>
            </div>
        </div>
                                            
                                           
                                        </div>
                                    </div>
                                    </div>
                                     <br />
                                    <div id="information">
                                        <div className="row">
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 about-desc p-4 m-0'>
                                                <h3>Why analyze your resting heart?</h3>
                                                <br />
                                                <p>
                                                Measuring your heart's resting state helps define your baseline heart health and assesses your risk profile. This service offers an analysis of your resting heart and provides lifestyle recommendations. The profiler is especially beneficial if your daily activities predominantly include:
                                                </p>
                                                <ul className="two-columns">
                                                    <li>Desk job</li>
                                                    <li>Long commute</li>
                                                    <li>Performing household chores</li>
                                                    <li>Unhealthy diet</li>

                                                </ul>
                                            </div>
                                            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex p-0 m-0'>
                                                <img
                                                    src={ProfilerBannerImg}
                                                    alt="Profiler"
                                                    className="img-fluid w-100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div id="beats">
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  m-0 beats-image">
                                                <img
                                                id='img2'
                                                    src={BeatsIcon}
                                                    alt="Beats"
                                                    className="img-fluid" 
                                                />
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  m-0 beats-content">
                                                <h3>How we do it:</h3>
                                                <p>We consider the below in order to evaluate your resting heart:</p>
                                                <ul>
                                                    <li>· Balance, assessing both physical and mental stress levels; </li>
                                                    <li>· Ageing, indicating the heart's wear and tear; and </li>
                                                    <li>· Stability, measuring how well your vitals maintain equilibrium without excessive exertion. 
                                                    </li>
                                                </ul>
                                                <p>
                                                Based on these factors, we offer a heart health score that reflects your resting heart health
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="timeline">
                                        <h2 className="small-heading">The process involves measuring your vitals, posing questions,and constructing a resting heart profile based on: </h2>
                                       
                                        <TimelineProfiler />
                                        <TimelineMobileProfiler />
                                        <div className="d-flex" id='try-now'>
                                        <a
                                            href={`${REACT_APP_CAD_CONSUMER_URL_PROFILER}`}
                                            target="_self"
                                            className="btn-try-now scrollto"
                                            onClick={(e) =>
                                                handleTryItNowClick(e, REACT_APP_CAD_CONSUMER_URL_PROFILER)
                                            }
                                        >
                                            Try it now
                                        </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade show" id="signature">
                                <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="journey-info-container">
                                        <h2>Signature</h2>
                                        <p>
                                        The signature is the lighthouse to your heart, providing comprehensive assessment of your resting and reactive heart. 
                                        </p>
                                        <p>
                                        Structured as a 7-day program, this service is inclusive of Profiler and aims to reveal your resting heart health and heart's capacity and recovery when you are active or under physical stress.
                                        </p>
                                        <br />
                                        <div className="d-flex" id='try-now'>
                                        <a
                                            href={`${REACT_APP_CAD_CONSUMER_URL_SIGNATURE}`}
                                            target="_self"
                                            className="btn-try-now scrollto"
                                            onClick={(e) =>
                                                handleTryItNowClick(e, REACT_APP_CAD_CONSUMER_URL_SIGNATURE)
                                            }
                                        >
                                            Try it now
                                        </a>
                                        </div>
                                        {/* <p>
                                            It is a 7 day analysis that will keep track of your reactive heart and also help uncover:
                                        </p> */}
                                        </div>
                                    </div>
                                         <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="row information-points">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0 m-0 d-flex align-items-center flex-column">
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Reactive heart health score</li>
            </div>
            <br />
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Burnout potential</li>
            </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0 m-0 d-flex align-items-center flex-column">
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Endurance & fitness</li>
            </div>
            <br />
            <div className="d-flex align-items-center flex-column">
                <img src={Star} alt="Profiler" className="star-icon" />
                <li>Lifestyle & clinical guidance</li>
            </div>
        </div>
                                            
                                           
                                        </div>
                                      
                                        </div>
                                    </div>

                                    <div id="information">
                                        <div className="row">
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 about-desc p-4 m-0'>
                                                <h3>Why monitor your reactive heart?</h3>
                                                <br />
                                                <p>
                                                Understanding how your heart responds to and recovers from physical stress provides valuable insights into your overall heart health. The Signature service is particularly suited for you if your typical activities include:
                                                </p>
                                                <ul className="multi-column-list">
                                                    <li>Exercising at the gym</li>
                                                    <li>Hiking</li>
                                                    <li>Running</li>
                                                    <li>Engaging in social events or partying</li>
                                                </ul>
                                            </div>
                                            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex p-0 m-0'>
                                                <img
                                                    src={SignatureBannerImg}
                                                    alt="Profiler"
                                                    className="img-fluid w-100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div id="beats">
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  m-0 beats-image">
                                                <img
                                                id='img3'
                                                    src={BeatsIcon}
                                                    alt="Beats"
                                                    className="img-fluid" 
                                                />
                                                <br />
                                                <br />
                                                 <p>
                                                 Utilizing data from reactive heart evaluations, we provide a detailed classification designed to support your activities, with the exception of extreme sports.
                                                </p>
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  m-0 beats-content">
                                                <h3>How we do it:</h3>
                                                <p>
                                                We consider the below in order to evaluate your resting and reactive heart:
                                                </p>
                                                <ul>
                                                    <li>· Balance, evaluating your response to physical and mental stress; </li>
                                                    <li>· Ageing, indicating the heart’s wear and tear; </li>
                                                    <li>· Stability, assessing how well your vitals manage under stress; </li>
                                                    <li>· Endurance, reflecting your fitness level; and</li>
                                                    <li>· Trends, identifying evolving health patterns. </li>
                                                </ul>
                                               
                                            </div>
                                        </div>
                                    </div>
                                    <div id="timeline" >
                                        <h2 className="small-heading">The process involves measuring your vitals, posing questions, and constructing a reactive heart profile based on: </h2>

                                        <TimelineSignature />
                                        <TimelineMobileSignature />

                                        <div className="d-flex">
                                        <a
                                            href={`${REACT_APP_CAD_CONSUMER_URL_SIGNATURE}`}
                                            target="_self"
                                            className="btn-try-now scrollto"
                                            onClick={(e) =>
                                                handleTryItNowClick(e, REACT_APP_CAD_CONSUMER_URL_SIGNATURE)
                                            }
                                        >
                                            Try it now
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

/* jscpd:ignore-end */

export default Services;
